import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import { reactSelectStyles } from '../helpers/utils.js';

class AsoFilter extends Component {
    state = {
        asoTypeLists: [],
        asoTypeValue: null,
        isasoLoading: true
    };

    componentDidMount() {
        this.getasoType();
    }

    restAsoFilter() {
        this.setState({
            asoTypeValue: null,
        });
    }

    getasoType() {
        axios.get(config.get('API_URL')+'/filters/get-aso-details/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {

                const asoList = response.data.map(aso => ({
                    value: aso.employee_id_and_name,
                    label: aso.employee_id_and_name
                }));

                this.setState({
                    asoTypeLists: asoList,
                    isasoLoading: false
                });

            } else {
                this.setState({
                    asoTypeLists: [],
                    isasoLoading: false
                });
            }

        });
    }

    changeasoType(optionSelected) {

        this.props.onSelectaso(optionSelected);

        this.setState({
            asoTypeValue: optionSelected,
        });
    }

    render() {

        // Parent se selected value aayi hai to use karo,
        // otherwise internal state use karo
        const selectedValue =
            this.props.value !== undefined
                ? this.props.value
                : this.state.asoTypeValue;

        return (
            <Select
                name="aso_type"
                value={selectedValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeasoType.bind(this)}
                options={this.state.asoTypeLists}
                isLoading={this.state.isasoLoading}
                isSearchable={true}
                placeholder="[Select Aso]"
            />
        );
    }
}

export default AsoFilter;